export const getObjectValue = (obj, key, defVal) => {
  return [undefined, null].indexOf(obj[key]) >= 0 ? defVal : `${obj[key]}`
}

export const getUrlParams = (search = location.search) => {
  let params = {};
  decodeURIComponent(search)
    .slice(1)
    .replace(/([^=&]+)=([^=&]+)/g, (x, k, v) => {
      params[k] = v;
      return x;
    });
  return params;
};

export const dateFormat = (format, date) => {
  var nowTime = new Date();
  var offset = nowTime.getTimezoneOffset() / 60;
  if (!date) {
    date = new Date();
  }
  date = new Date(date.getTime() + 60000 * 60 * (offset + 8));
  const o = {
    "y+": date.getYear(), //year
    "M+": date.getMonth() + 1, //month
    "d+": date.getDate(), //day
    "h+": date.getHours(), //hour
    "H+": date.getHours(), //hour
    "m+": date.getMinutes(), //minute
    "s+": date.getSeconds(), //second
    "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
    S: date.getMilliseconds(), //millisecond
  };
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return format;
};

export const priceFormat = (num) => {
  if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(num)) {
    return;
  }
  var unit = "仟佰拾亿仟佰拾万仟佰拾元角分",
    str = "";
  num += "00";
  var p = num.indexOf(".");
  if (p >= 0) num = num.substring(0, p) + num.substr(p + 1, 2);
  unit = unit.slice(unit.length - num.length);
  for (var i = 0; i < num.length; i++) str += "零壹贰叁肆伍陆柒捌玖".charAt(num.charAt(i)) + unit.charAt(i);
  return str
    .replace(/零(仟|佰|拾|角)/g, "零")
    .replace(/(零)+/g, "零")
    .replace(/零(万|亿|元)/g, "$1")
    .replace(/(亿)万|壹(拾)/g, "$1$2")
    .replace(/^元零?|零分/g, "")
    .replace(/元$/g, "元整");
}
// 两个浮点数求和
export function accAdd(num1, num2) {
  let r1, r2, m;
  try {
    r1 = num1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = num2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  // return (num1*m+num2*m)/m;
  return Math.round(num1 * m + num2 * m) / m;
}

// 两个浮点数相减
export function accSub(num1, num2) {
  let r1, r2, m, n;
  try {
    r1 = num1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = num2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  n = r1 >= r2 ? r1 : r2;
  return (Math.round(num1 * m - num2 * m) / m).toFixed(n);
}
// 两数相除
export function accDiv(num1, num2) {
  let t1, t2, r1, r2;
  try {
    t1 = num1.toString().split(".")[1].length;
  } catch (e) {
    t1 = 0;
  }
  try {
    t2 = num2.toString().split(".")[1].length;
  } catch (e) {
    t2 = 0;
  }
  r1 = Number(num1.toString().replace(".", ""));
  r2 = Number(num2.toString().replace(".", ""));
  return (r1 / r2) * Math.pow(10, t2 - t1);
}
// 两数相乘
export function accMul(num1, num2) {
  let m = 0,
    s1 = num1.toString(),
    s2 = num2.toString();
  try {
    m += s1.split(".")[1].length;
  } catch (e) {}
  try {
    m += s2.split(".")[1].length;
  } catch (e) {}
  return (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) / Math.pow(10, m);
}

function S4() {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}

//生成唯一标识
export function createUniqueId() {
  return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}

export function transformTO(n) {
  if(!n && n !== 0) return '';
  var fraction = ["角", "分"];
  var digit = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
  var unit = [
    [
      "元",
      "万",
      "亿",
      "万亿",
      "万万亿",
      "万万万亿",
      "万万万万亿",
      "万万万万万亿"
    ],
    ["", "拾", "佰", "仟"]
  ];
  var head = n < 0 ? "欠" : "";
  n = Math.abs(n);
  if (n === NaN) return "零元整";
  var s = "";
  for (var i = 0; i < fraction.length; i++) {
    s += (
      digit[Math.floor(n * 10 * Math.pow(10, i) + 0.000001) % 10] +
      fraction[i]
    ).replace(/零./, "");
  }
  s = s || "整";
  n = Math.floor(n);
  for (var i = 0; i < unit[0].length && n > 0; i++) {
    var p = "";
    for (var j = 0; j < unit[1].length && n > 0; j++) {
      p = digit[n % 10] + unit[1][j] + p;
      n = Math.floor(n / 10);
    }
    s = p.replace(/(零.)*零$/, "").replace(/^$/, "零") + unit[0][i] + s;
  }
  s = s
    .replace(/(零.)*零元/, "元")
    .replace(/(零.)+/g, "零")
    .replace(/^整$/, "零元整");
  if (s.indexOf("元") === -1) s = "零元" + s;
  return head + s;
}

export const download = (href) => {
  let btn = document.createElement('a')
  btn.style.display = 'none'
  btn.download = href.replace(/.+\/(^\/+)$/, '$1')
  btn.href = href
  btn.click()
}
